// export function calculateMaxPlantsInBed(length, width, plantRowDistance, plantDistanceInRow) {
//   // Calculate the number of plants based on rows along the length
//   let rowsLength = Math.floor(length / plantRowDistance);
//   let plantsInRowLength = Math.floor(width / plantDistanceInRow);
//   let totalPlantsLength = rowsLength * plantsInRowLength;
//
//   // Calculate the number of plants based on rows along the width
//   let rowsWidth = Math.floor(width / plantRowDistance);
//   let plantsInRowWidth = Math.floor(length / plantDistanceInRow);
//   let totalPlantsWidth = rowsWidth * plantsInRowWidth;
//
//   // Return the maximum number of plants
//   return Math.max(totalPlantsLength, totalPlantsWidth);
// }
//

import dayjs from "dayjs";
import {LOOM_VIDEOS, PLANTING_STATUS} from "./constants";

export function calculateMaxPlantsInBed(length, width, plantRowDistance, plantDistanceInRow) {
    // Number of rows we can have in the bed
    const rows = Math.floor(length / plantRowDistance);

    // Number of plants we can have in a row
    const plantsInRow = Math.floor(width / plantDistanceInRow);

    // Total number of plants
    const totalPlants = rows * plantsInRow;

    return totalPlants;
}

export function safeFormatDate(date, format = 'YYYY-MM-DD') {
    if (!date || !date.isValid || !date.isValid()) return null;
    const formatted = date.format(format);
    if (formatted === 'Invalid Date') return null;
    return formatted;
}

export function setUtmData() {
    // Capture UTM parameters and supplier_ids from URL and store them in localStorage
    const urlParams = new URLSearchParams(window.location.search);
    const utmSource = urlParams.get('utm_source');
    const utmMedium = urlParams.get('utm_medium');
    const utmCampaign = urlParams.get('utm_campaign');
    const supplierIds = urlParams.get('supplier_ids');

    if (utmSource || utmMedium || utmCampaign || supplierIds) {
        const utmData = {
            utm_source: utmSource,
            utm_medium: utmMedium,
            utm_campaign: utmCampaign,
            supplier_ids: supplierIds,
            timestamp: Date.now()
        };
        localStorage.setItem('utm_data', JSON.stringify(utmData));
    }
}


export function getFirstSowableDate(crop) {
    let month_min= crop.sow_min
    let month_max = crop.sow_max;

    if (crop.is_seedling) {
        month_min = crop.plant_min
        month_max = crop.plant_max
    }

    const today = dayjs();
    const currentYear = today.year();
    const currentMonth = today.month() + 1; // dayjs months are 1-based

    // Handle year-spanning ranges (e.g., sow in Oct-Feb means month_min=10, month_max=2)
    if (month_min > month_max) {
        // Range spans year boundary (e.g., October to February)
        // Valid months are: month_min to 12, then 1 to month_max
        if (currentMonth >= month_min || currentMonth <= month_max) {
            return today; // Today is within the range
        }

        // Current month is between month_max and month_min (outside the range)
        // Next valid date is month_min of this year
        return dayjs(`${currentYear}-${month_min}-01`);
    }

    if (currentMonth >= month_min && currentMonth <= month_max) {
        return today; // Today is within the range
    }

    // Find the first available month in the range
    for (let month = month_min; month <= month_max; month++) {
        if (month > currentMonth) {
            return dayjs(`${currentYear}-${month}-01`);
        }
    }

    // If all months are in the past, return the first valid month next year
    return dayjs(`${currentYear + 1}-${month_min}-01`);
}

/**
 *     is_direct_sown = Column(Boolean, default=True)
 *     is_pricked_out = Column(Boolean, default=False)
 *     is_multiple_harvestable = Column(Boolean, default=False)
 *
 *     buffer_days = Column(Integer, nullable=True)
 *     germination_days = Column(Integer, nullable=True)
 *     prick_out_days = Column(Integer, nullable=True)
 *     plant_out_days = Column(Integer, nullable=True)
 *     maturity_days = Column(Integer, nullable=True)
 *     harvest_days = Column(Integer, nullable=True)
 *     harvest_count = Column(Integer, nullable=True)
 *
 */

/**
 * Calculate the month difference accounting for year boundaries.
 * For example: from October (10) to March (3) = 5 months (Oct->Nov->Dec->Jan->Feb->Mar)
 */
function monthDifference(fromMonth, toMonth) {
    if (toMonth >= fromMonth) {
        return toMonth - fromMonth;
    }
    // Spans year boundary: count months from fromMonth to Dec, then Jan to toMonth
    return (12 - fromMonth) + toMonth;
}

function calculateCropDays(crop) {

    let plant_min = crop.plant_min ? crop.plant_min : crop.sow_min;

    if (crop.is_seedling) {
        crop.sow_min = crop.plant_min
        crop.sow_max = crop.plant_max
    }

    let harvestDates = [];
    let daysToPrick = 0;
    let daysToTransplant = monthDifference(crop.sow_min, plant_min) * 31;
    let daysToMature = monthDifference(plant_min, crop.harvest_min) * 31;
    let daysToLastHarvest = monthDifference(crop.harvest_min, crop.harvest_max) * 31;

    if (crop.is_fully_configured) {
        if (crop.is_direct_sown) {
            daysToPrick = 0;
            daysToTransplant = 0;
        } else {
            daysToPrick = crop.prick_out_days ? crop.prick_out_days : 0;
            daysToTransplant = crop.plant_out_days;
        }

        daysToMature = crop.maturity_days;
        if (!crop.is_multiple_harvestable) {
            daysToLastHarvest = 0
        } else {
            for (let i = 1; i < crop.harvest_count; i++) {
                harvestDates.push((crop.harvest_days * i))
            }
            daysToLastHarvest = (crop.harvest_days * crop.harvest_count);
        }
    }

    return {
        daysToGerminate: parseInt(crop.germination_days ? crop.germination_days : 0),
        daysToPrick: parseInt(daysToPrick),
        daysToTransplant: parseInt(daysToTransplant),
        daysToMature: parseInt(daysToMature),
        daysToLastHarvest: parseInt(daysToLastHarvest),
        harvestDates: harvestDates
    }
}

export function calculateCropDates(crop, user_sow_at) {

    const sow_at = user_sow_at ? user_sow_at : getFirstSowableDate(crop);

    const {
        daysToGerminate,
        daysToPrick,
        daysToTransplant,
        daysToMature,
        daysToLastHarvest,
        harvestDates
    } = calculateCropDays(crop);

    return {
        sow_at: sow_at,
        germinate_at: sow_at.add(daysToGerminate, 'days'),
        prick_at: sow_at.add(daysToGerminate + daysToPrick, 'days'),
        transplant_at: sow_at.add(daysToGerminate + daysToPrick + daysToTransplant, 'days'),
        harvest_at: sow_at.add(daysToGerminate + daysToPrick + daysToTransplant + daysToMature, 'days'),
        harvest_until: sow_at.add(daysToGerminate + daysToPrick + daysToTransplant + daysToMature + daysToLastHarvest, 'days'),
        harvest_dates: harvestDates.map((days) => sow_at.add(daysToGerminate + daysToPrick + daysToTransplant + daysToMature + days, 'days'))
    }
}

export function calculateCropDatesFromPlanting(crop, user_transplant_date) {
    if (!user_transplant_date) {
        return calculateCropDates(crop)
    }

    const transplant_at = user_transplant_date

    const {
        daysToPrick,
        daysToTransplant,
    } = calculateCropDays(crop);

    const sow_at = transplant_at.subtract(daysToPrick + daysToTransplant, 'days')
    return calculateCropDates(crop, sow_at)
}

export function calculateCropDatesFromHarvest(crop, user_harvest_date) {
    if (!user_harvest_date) {
        return calculateCropDates(crop)
    }

    const harvest_at = user_harvest_date;

    const {
        daysToGerminate,
        daysToPrick,
        daysToTransplant,
        daysToMature,
    } = calculateCropDays(crop);

    const sow_at = harvest_at.subtract(daysToMature + daysToPrick + daysToTransplant + daysToGerminate, 'days')
    return calculateCropDates(crop, sow_at)
}

export function calculateRowsAndPlants(bed, crop) {

    const rows = Math.floor(bed.width / crop.row_distance);
    const plants = Math.floor(bed.length / crop.plant_distance);

    return {
        rows: rows === 0 ? 1 : rows,
        plants_per_row: plants === 0 ? 1 : plants
    }
}

export function bedDimensionsToHuman(bed, measurementSystem = 'metric') {
    const { getDisplayUnit } = require('./utils/measurements');

    if (measurementSystem === 'imperial') {
        return `${bed.width}${getDisplayUnit(measurementSystem, 'length')}x${bed.length}${getDisplayUnit(measurementSystem, 'length')}`
    }

    let width = bed.width
    let widthUnit = "cm"

    let length = bed.length
    let lengthUnit = "cm"

    if (bed.width > 100) {
        width = bed.width / 100
        widthUnit = "m"
    }
    if (bed.length > 100) {
        length = bed.length / 100
        lengthUnit = "m"
    }

    // Show values with appropriate units (no conversion)
    const displayWidthUnit = getDisplayUnit(measurementSystem, widthUnit === 'm' ? 'height' : 'length');
    const displayLengthUnit = getDisplayUnit(measurementSystem, lengthUnit === 'm' ? 'height' : 'length');

    return `${width}${displayWidthUnit}x${length}${displayLengthUnit}`
}


export function filterPlanting(p, endDate, hideHarvested, search = "") {
    if (!hideHarvested) {
        hideHarvested = localStorage.getItem('hideHarvested') === 'true'
    }

    // Filter out everything without a crop
    if (!p.crop) {
        return false
    }

    if (!p.harvest_at && !p.sow_at && !p.transplant_at) {
        return true
    }

    if (hideHarvested && p.status === PLANTING_STATUS.HARVESTED) {
        return false
    }

    return true
}

export function getVideoForPage(location) {
    const video = LOOM_VIDEOS.filter((video) => {
        return location.pathname.startsWith(video.pathname)
    })

    if (video.length > 0) {
        return video[0].loom
    }
    return null
}

export function formatPlanPrice(price, currency = 'EUR') {
    const safeCurrency = currency === 'USD' ? 'USD' : 'EUR'
    return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: safeCurrency,
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    }).format(price)
}

export function printPrice(price, showFree = false) {
    if(price === 0 && showFree) {
        return 'Gratis!'
    }
    return `€ ${price.toFixed(2).replace('.', ',')}`
}

export function noteToParagraph(note) {
    if (!note) {
        return ""
    }

    const lines = note.split('\n');
    return lines.map((line, index) => {
        return <p key={index}>{line}</p>
    })
}

export const pickUpSlotToHuman = (slot) => {
    return (<>{dayjs().day(slot.day_of_week + 1).format('dddd')} van {`${String(slot.starts_at).padStart(2, '0')}:00`} tot {`${String(slot.ends_at).padStart(2, '0')}:00`}</>)
}

export const isValidIban = (iban) => {
    const cleaned = iban.replace(/\s+/g, '').toUpperCase();
    if (!/^[A-Z]{2}\d{2}[A-Z0-9]+$/.test(cleaned)) return false;

    const rearranged = cleaned.slice(4) + cleaned.slice(0, 4);
    const converted = rearranged
        .split('')
        .map(ch => /[A-Z]/.test(ch) ? (ch.charCodeAt(0) - 55).toString() : ch)
        .join('');

    let remainder = '';
    for (const digit of converted) {
        remainder += digit;
        const num = parseInt(remainder, 10);
        if (num >= 97) {
            remainder = (num % 97).toString();
        } else if (remainder.length > 9) {
            // Prevent JS integer overflow in parseInt
            remainder = (num % 97).toString();
        }
    }

    return parseInt(remainder, 10) === 1;
}